import "./App.css";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import axios from "axios";
import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import animacaoJson from "./btck-loading.json";
import animacaoJsonError from "./erro-back.json";
import { asaasGetPaymentInfos } from "./services/asaas/asaasGetPaymentInfos";
import { asaasGeneratePixPayment } from "./services/asaas/asaasGeneratePixPayment";
import { Icon } from "@iconify/react";
import { asaasGeneratePaymentSlip } from "./services/asaas/asaasGeneratePaymentSlip";
import { assasVerifyPayment } from "./services/asaas/assasVerifyPayment";
import { asaasVerifyCustomer } from "./services/asaas/asaasVerifyCustomer";

function App() {
  const [dataPayment, setDataPayment] = useState({ success: true });
  const [requestSuccess, setRequestSuccess] = useState(null);
  const [savePayment, setSavePayment] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState(null);
  const path = window.location.pathname;
  const quote = path.split("/")[1];
  const complement = path.split("/")[2];

  const params = new URLSearchParams(window.location.search);
  const typePayment = params.get("type");

  const plateQuery = params.get("plate");
  const phoneQuery = params.get("phone");
  const emailQuery = params.get("email");
  // const typeQuery = params.get("type"); // removido pois não é utilizado
  const documentQuery = params.get("document");
  const cepQuery = params.get("cep");
  const [viaCepAddress, setViaCepAddress] = useState(null);

  useEffect(() => {
    if (!cepQuery) return;
    const cepClean = cepQuery.replace(/[^\d]/g, "");
    if (cepClean.length !== 8) return;

    axios
      .get(`https://viacep.com.br/ws/${cepClean}/json/`)
      .then(({ data }) => {
        if (data?.erro) return;
        setViaCepAddress({
          street: data.logradouro,
          neighborhood: data.bairro,
          city: data.localidade,
          state: data.uf,
          cep: cepClean,
        });
      })
      .catch(() => { });
  }, [cepQuery]);

  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const [pixPaymentInfos, setPixPaymentInfos] = useState(null);
  const [paymentSlipInfos, setPaymentSlipInfos] = useState(null);
  const [pixCopied, setPixCopied] = useState(false);
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);
  const [isCreatingVehicleLookup, setIsCreatingVehicleLookup] = useState(false);
  const [isProcessingPixPayment, setIsProcessingPixPayment] = useState(false);
  const [isCheckingPayment, setIsCheckingPayment] = useState(false);

  let uuidOrder;
  let type;
  let paymentId

  // Função para criar vehicle lookup - executa apenas quando chamada
  const createVehicleLookup = async (paymentId) => {
    // Prevenir chamadas duplicadas
    if (isCreatingVehicleLookup) {
      console.log("Vehicle lookup já está sendo criado, ignorando chamada duplicada");
      return;
    }

    setIsCreatingVehicleLookup(true);
    try {
      const response = await axios.post('/general-api/create/vehicle-lookup', {
        plate: plateQuery || "",
        email: emailQuery || "",
        type: typePayment || "plus",
        phone: phoneQuery || "",
        paymentId
      });

      console.log("Vehicle lookup criado:", response.data);

      // Se a resposta contém dados de pagamento, atualizar o estado
      if (response.data) {
        setDataPayment(response.data);
      }
      
      return response.data;
    } catch (error) {
      console.error("Erro ao criar vehicle lookup:", error);
      // Não bloquear a aplicação em caso de erro
      throw error;
    } finally {
      setIsCreatingVehicleLookup(false);
    }
  };

  const handleAsaasPixPayment = async () => {
    // Prevenir chamadas duplicadas
    if (isProcessingPixPayment) {
      console.log("Pagamento PIX já está sendo processado, ignorando chamada duplicada");
      return;
    }

    setIsProcessingPixPayment(true);
    setIsLoadingPayment(true);
    
    try {
      // Primeiro, verificar se o usuário já é cliente Asaas
      const customerVerification = await asaasVerifyCustomer({
        document: documentQuery,
        name: emailQuery
      });

      if (!customerVerification?.success) {
        setRequestSuccess(false);
        setIsLoadingPayment(false);
        setIsProcessingPixPayment(false);
        return;
      }

      const generatePixPayment = await asaasGeneratePixPayment({
        asaasCustomerId: customerVerification?.asaasCustomerId,
        value: plateQuery === "ABC1234" ? 5 : 59.9,
        description: `LK_${plateQuery}-${phoneQuery}`,
      });

      paymentId = generatePixPayment?.paymentId
      await createVehicleLookup(paymentId)

      if (!generatePixPayment?.success) {
        setRequestSuccess(false);
        setIsLoadingPayment(false);
        setIsProcessingPixPayment(false);
        return;
      }

      const paymentInfos = await asaasGetPaymentInfos({
        paymentId: generatePixPayment?.paymentId,
        type: "pixQrCode",
      });

      if (!paymentInfos?.success) {
        setRequestSuccess(false);
        setIsLoadingPayment(false);
        setIsProcessingPixPayment(false);
        return;
      }

      setPixPaymentInfos({
        paymentId: generatePixPayment?.paymentId,
        image: paymentInfos?.paymentImage,
        payload: paymentInfos?.paymentPayload,
      });

      setIsLoadingPayment(false);
    } catch (error) {
      console.error("Erro ao processar pagamento PIX:", error);
      setRequestSuccess(false);
      setIsLoadingPayment(false);
      setIsProcessingPixPayment(false);
    }
  };

  const handleAsaasPaymentSlip = async () => {
    setIsLoadingPayment(true);

    const generatePaymentSlip = await asaasGeneratePaymentSlip({
      asaasCustomerId: dataPayment?.customer?.asaasCustomerId,
      value: 59.9,
      description: `${plateQuery}-${phoneQuery}`,
    });

    if (!generatePaymentSlip?.success) {
      setRequestSuccess(false);
      setIsLoadingPayment(false);
      return;
    }

    setPaymentSlipInfos({
      paymentId: generatePaymentSlip?.paymentId,
      bankSlipUrl: generatePaymentSlip?.bankSlipUrl,
    });

    window.open(generatePaymentSlip?.bankSlipUrl, "_blank");

    setIsLoadingPayment(false);
  };

  const handleCopyPixCode = ({ link }) => {
    // Fallback para dispositivos móveis e contextos inseguros
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(link)
        .then(() => {
          setPixCopied(true);
          setTimeout(() => {
            setPixCopied(false);
          }, 2000);
        })
        .catch(() => {
          // Se falhar, usa o método de fallback
          fallbackCopyTextToClipboard(link);
        });
    } else {
      // Método de fallback para dispositivos que não suportam clipboard API
      fallbackCopyTextToClipboard(link);
    }
  };

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Evita scroll para o elemento
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
      setPixCopied(true);
      setTimeout(() => {
        setPixCopied(false);
      }, 2000);
    } catch (err) {
      console.error("Erro ao copiar texto: ", err);
    }

    document.body.removeChild(textArea);
  };

  useEffect(() => {
    if (!dataPayment) return;

    if (selectedPaymentMethod === "pix" && !pixPaymentInfos && !isProcessingPixPayment) {
      handleAsaasPixPayment();
    }

    if (selectedPaymentMethod === "paymentSlip" && !paymentSlipInfos) {
      handleAsaasPaymentSlip();
    }

    if (selectedPaymentMethod === "paymentSlip" && paymentSlipInfos) {
      window.open(paymentSlipInfos?.bankSlipUrl, "_blank");
    }
  }, [selectedPaymentMethod, dataPayment]);

  useEffect(() => {
    const handleVehicleLookup = async () => {
      if (selectedPaymentMethod === 'credit_card' && !isCreatingVehicleLookup) {
        await createVehicleLookup("");
      }
    };
    handleVehicleLookup();
  }, [selectedPaymentMethod]);

  // Polling para verificar status do pagamento PIX
  useEffect(() => {
    if (!pixPaymentInfos?.paymentId || paymentConfirmed) {
      return;
    }

    console.log("🔍 Iniciando polling de verificação de pagamento PIX:", pixPaymentInfos.paymentId);

    let intervalId;
    let attempts = 0;
    const maxAttempts = 60; // 5 minutos (60 * 5 segundos)
    let isChecking = false;

    const checkPaymentStatus = async () => {
      if (attempts >= maxAttempts) {
        console.log("⏱️ Tempo limite de verificação atingido");
        clearInterval(intervalId);
        return;
      }

      if (isChecking) {
        console.log("⏭️ Verificação anterior ainda em andamento, pulando...");
        return;
      }

      attempts++;
      isChecking = true;

      try {
        const result = await assasVerifyPayment({
          paymentId: pixPaymentInfos.paymentId,
        });

        console.log(`🔎 Verificação ${attempts}/${maxAttempts} - Status:`, result?.status);

        if (result?.success && (result?.status === "CONFIRMED" || result?.status === "RECEIVED")) {
          console.log("✅ Pagamento confirmado! Status:", result?.status);
          setPaymentConfirmed(true);
          clearInterval(intervalId);
          
          // Enviar mensagem de sucesso após 3 segundos
          setTimeout(() => {
            console.log("📤 Enviando postMessage de confirmação");
            window.parent.postMessage(
              { success: true, data: "payment", paymentId: pixPaymentInfos.paymentId },
              "*"
            );
          }, 3000);
        }
      } catch (error) {
        console.error("❌ Erro ao verificar pagamento:", error);
      } finally {
        isChecking = false;
      }
    };

    // Inicia verificação após 5 segundos e repete a cada 5 segundos
    const timeoutId = setTimeout(() => {
      console.log("⏰ Primeira verificação iniciando...");
      checkPaymentStatus(); // Primeira verificação
      intervalId = setInterval(checkPaymentStatus, 5000); // Verificações subsequentes
    }, 5000);

    // Cleanup
    return () => {
      console.log("🧹 Limpando polling de pagamento");
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
    };
  }, [pixPaymentInfos, paymentConfirmed]);

  // useEffect(() => {
  //   axios
  //     .get(
  //       `/webapp/infos/${uuidOrder}?type=${
  //         type === "carWorkshop" ? "quote" : type
  //       }`,
  //       {
  //         headers: {
  //           "ngrok-skip-browser-warning": "true",
  //           "Content-Type": "application/json",
  //           jwt: process.env.REACT_APP_DEFAULT_WEBAPP_BACKEND_JWT,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       setDataPayment(response.data.infos);
  //     })
  //     .catch((error) => {
  //       setDataPayment({});
  //       // setRequestSuccess(false);
  //     });
  // }, []);

  // Render payment method selection screen if no method is selected yet
  if (selectedPaymentMethod === null) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h2>Selecione a forma de pagamento</h2>
        {typePayment === "carWorkshop" &&
          uuidOrder === "2430d191-b3da-4ff2-8634-88fb0fccd024" && (
            <>
              <h4>Pague, e veja as informações das oficinas</h4>
              <button
                onClick={() => {
                  axios
                    .post(
                      `/webapp/approve/payment/${uuidOrder}?type=${type}`,
                      { dev: "dev" },
                      {
                        headers: {
                          "ngrok-skip-browser-warning": "true",
                          "Content-Type": "application/json",
                          jwt: process.env.REACT_APP_DEFAULT_WEBAPP_BACKEND_JWT,
                        },
                      }
                    )
                    .then((response) => {
                      setPaymentConfirmed(true);
                      setTimeout(() => {
                        window.parent.postMessage(
                          { success: true, data: "payment" },
                          "*"
                        );
                      }, 3000);
                    });
                }}
                style={{
                  padding: "15px",
                  fontSize: "16px",
                  backgroundColor: "#32BBAD",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <span>###</span>
                <span>TESTAR PAGAMENTO</span>
                <span>###</span>
              </button>
            </>
          )}
        {uuidOrder === "2430d191-b3da-4ff2-8634-88fb0fccd024" && (
          <>
            <h4>Pague, e realize o agendamento</h4>
            <button
              onClick={() => {
                axios
                  .post(
                    `/webapp/approve/payment/${uuidOrder}?type=${type}`,
                    {
                      orderID: "7MB60537YE632835C",
                      payerID: "6DFH74JKT84RE",
                      paymentID: "7MB60537YE632835C",
                      billingToken: null,
                      facilitatorAccessToken:
                        "A21AAMvsB90g43nnDTGU7pwdU8ccsO-1A8cYutq_WMBRGIgfHufv6h29mZdmAMJqm7T6La5KVW9HevFDy2RaAULtP-LSNndVA",
                      paymentSource: "card",
                    },
                    {
                      headers: {
                        "ngrok-skip-browser-warning": "true",
                        "Content-Type": "application/json",
                        jwt: process.env.REACT_APP_DEFAULT_WEBAPP_BACKEND_JWT,
                      },
                    }
                  )
                  .then((response) => {
                    window.parent.postMessage(
                      { success: true, data: "payment" },
                      "*"
                    );
                  });
              }}
              style={{
                padding: "15px",
                fontSize: "16px",
                backgroundColor: "#32BBAD",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <span>###</span>
              <span>TESTAR PAGAMENTO ORCAMENTO</span>
              <span>###</span>
            </button>
          </>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            marginTop: "30px",
          }}
        >
          <button
            onClick={() => setSelectedPaymentMethod("pix")}
            style={{
              padding: "15px",
              fontSize: "16px",
              backgroundColor: "#32BBAD",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <span>Pagar com Pix</span>
            <span>⚡</span>
          </button>

          <button
            onClick={() => setSelectedPaymentMethod("credit_card")}
            style={{
              padding: "15px",
              fontSize: "16px",
              backgroundColor: "#003087",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <span>Pagar com Cartão de Crédito</span>
            <span>💳</span>
          </button>
          {/* <button
            onClick={() => setSelectedPaymentMethod("paymentSlip")}
            style={{
              padding: "15px",
              fontSize: "16px",
              backgroundColor: "#19769A",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <span>Pagar com Boleto</span>
            <span>🧾</span>
          </button> */}
        </div>
      </div>
    );
  }

  // Render Pix payment screen
  if (selectedPaymentMethod === "pix") {
    return (
      <>
        <div style={{ padding: "20px" }}></div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginLeft: "20px",
          }}
          onClick={() => setSelectedPaymentMethod(null)}
        >
          <img src="/back.png" alt="" width={40} />
        </div>

        <div style={{ padding: "15px" }}>
          {dataPayment?.totalParts && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Peças:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(
                  typePayment === "carWorkshop" ? 0 : dataPayment.totalParts
                )}
              </p>
            </div>
          )}

          {dataPayment?.totalServices && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Serviços:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(
                  typePayment === "carWorkshop" ? 0 : dataPayment.totalServices
                )}
              </p>
            </div>
          )}

          {typePayment === "carWorkshop" && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>
                Visualização das oficinas:
              </p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(59.9)}
              </p>
            </div>
          )}

          {type === "quote" && dataPayment?.canUserSeeCarWorkshops === true && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>
                Visualização das oficinas:
              </p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                -{" "}
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(59.9)}
              </p>
            </div>
          )}

          {dataPayment?.totalToPay && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
              }}
            >
              <p style={{ textAlign: "left", margin: "5px" }}>Subtotal:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(
                  typePayment === "carWorkshop"
                    ? 59.9
                    : dataPayment?.canUserSeeCarWorkshops
                      ? dataPayment.totalToPay - 59.9
                      : dataPayment.totalToPay
                )}
              </p>
            </div>
          )}
        </div>
        <div style={{ padding: "20px", textAlign: "center" }}>
          {isLoadingPayment ? (
            <p>Carregando ...</p>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "1rem",
                padding: "10px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  padding: "1rem",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  marginBottom: "1rem",
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "12px",
                    wordBreak: "break-all",
                    textAlign: "center",
                    color: "#333",
                  }}
                >
                  {pixPaymentInfos?.payload}
                </p>
              </div>

              <button
                onClick={() =>
                  handleCopyPixCode({
                    link: pixPaymentInfos?.payload,
                  })
                }
                style={{
                  padding: "12px 24px",
                  fontSize: "14px",
                  backgroundColor: pixCopied ? "#28a745" : "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  transition: "background-color 0.3s ease",
                  marginBottom: "1rem",
                }}
              >
                {pixCopied ? "✓ Copiado com sucesso!" : "Copiar Chave PIX"}
              </button>

              <p
                style={{
                  margin: "0 0 1rem 0",
                  fontSize: "14px",
                  color: "#666",
                }}
              >
                ou
              </p>

              <img
                src={`data:image/png;base64,${pixPaymentInfos?.image}`}
                width={200}
                alt="Pix QRCode"
              />
            </div>
          )}
        </div>

        {/* Modal de confirmação de pagamento PIX */}
        {paymentConfirmed && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#4CAF50",
              color: "white",
              padding: "30px",
              borderRadius: "15px",
              textAlign: "center",
              boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
              zIndex: 1000,
              maxWidth: "90%",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            <div style={{ marginBottom: "15px" }}>
              <Icon
                icon="mdi:check-circle"
                style={{ fontSize: "48px", color: "white" }}
              />
            </div>
            <div>Pagamento confirmado!</div>
            <div
              style={{
                fontSize: "14px",
                marginTop: "10px",
                fontWeight: "normal",
              }}
            >
              Em breve enviaremos o relatório por WhatsApp.
            </div>
          </div>
        )}
      </>
    );
  }

  // Render Boleto payment screen
  if (selectedPaymentMethod === "paymentSlip") {
    return (
      <>
        <div style={{ padding: "20px" }}></div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginLeft: "20px",
          }}
          onClick={() => setSelectedPaymentMethod(null)}
        >
          <img src="/back.png" alt="" width={40} />
        </div>

        <div style={{ padding: "15px" }}>
          {dataPayment?.totalParts && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Peças:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(
                  typePayment === "carWorkshop" ? 0 : dataPayment.totalParts
                )}
              </p>
            </div>
          )}

          {dataPayment?.totalServices && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Serviços:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(
                  typePayment === "carWorkshop" ? 0 : dataPayment.totalServices
                )}
              </p>
            </div>
          )}

          {typePayment === "carWorkshop" && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>
                Visualização das oficinas:
              </p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(59.9)}
              </p>
            </div>
          )}

          {type === "quote" && dataPayment?.canUserSeeCarWorkshops === true && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>
                Visualização das oficinas:
              </p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                -{" "}
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(59.9)}
              </p>
            </div>
          )}

          {dataPayment?.totalToPay && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
              }}
            >
              <p style={{ textAlign: "left", margin: "5px" }}>Subtotal:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(
                  typePayment === "carWorkshop"
                    ? 59.9
                    : dataPayment?.canUserSeeCarWorkshops
                      ? dataPayment.totalToPay - 59.9
                      : dataPayment.totalToPay
                )}
              </p>
            </div>
          )}
        </div>
        <div style={{ padding: "20px", textAlign: "center" }}>
          {isLoadingPayment ? (
            <p>Carregando ...</p>
          ) : (
            <p>
              Após o pagamento, seu orçamento será atualizado em até 24 horas.
            </p>
          )}
        </div>
      </>
    );
  }

  // Render credit card payment flow
  return (
    <>
      <div style={{ padding: "20px" }}></div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          marginLeft: "20px",
        }}
        onClick={() => setSelectedPaymentMethod(null)}
      >
        <img src="/back.png" alt="" width={40} />
      </div>

      {plateQuery === "ABC1234" && (
        <>
          <h4>Pague, e realize o agendamento</h4>
          <button
            onClick={() => {
              axios
                .post(
                  `/general-api/vehicle-query`,
                  {
                    plate: plateQuery,
                    phone: phoneQuery,
                    email: emailQuery,
                    document: documentQuery,
                    cep: viaCepAddress.cep,
                    type: "plus",
                    paymentCode: "5P55468663204880A",
                  },
                  {
                    headers: {
                      "Content-Type": "application/json",
                    },
                  }
                )
                .then((response) => {
                  setPaymentConfirmed(true);
                  setProcessing(false);
                })
                .catch((error) => {
                  setSavePayment(false);
                  console.error(error);
                });
            }}
            style={{
              padding: "15px",
              fontSize: "16px",
              backgroundColor: "#32BBAD",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <span>###</span>
            <span>TESTAR PAGAMENTO CLICK CONSULTA</span>
            <span>###</span>
          </button>
        </>
      )}

      <div style={{ padding: "15px" }}>
        {/* {dataPayment?.totalParts && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ textAlign: "left", margin: "5px" }}>Peças:</p>
            <p style={{ textAlign: "right", margin: "5px" }}>
              {new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(typePayment === "carWorkshop" ? 0 : dataPayment.totalParts)}
            </p>
          </div>
        )} */}

        {/* {dataPayment?.totalServices && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ textAlign: "left", margin: "5px" }}>Serviços:</p>
            <p style={{ textAlign: "right", margin: "5px" }}>
              {new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(typePayment === "carWorkshop" ? 0 : dataPayment.totalServices)}
            </p>
          </div>
        )} */}

        {/* {typePayment === "carWorkshop" && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ textAlign: "left", margin: "5px" }}>Visualização das oficinas:</p>
            <p style={{ textAlign: "right", margin: "5px" }}>
              {new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(59.9)}
            </p>
          </div>
        )} */}

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p style={{ textAlign: "left", margin: "5px" }}>
            CLICK PESQUISA VEICULAR
          </p>
          <p style={{ textAlign: "right", margin: "5px" }}>
            {new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(59.9)}
          </p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontWeight: "bold",
          }}
        >
          <p style={{ textAlign: "left", margin: "5px" }}>Subtotal:</p>
          <p style={{ textAlign: "right", margin: "5px" }}>
            {new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(59.9)}
          </p>
        </div>
      </div>
      <PayPalScriptProvider
        options={{
          "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
          currency: "BRL",
        }}
      >
        {/* <p>Pague de forma 100% segura</p> */}

        {!dataPayment && requestSuccess === null && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "80%",
              }}
            >
              <p>Carregando...</p>
              <Lottie animationData={animacaoJson} loop={true} />
            </div>
          </div>
        )}

        {requestSuccess === false && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "80%",
              }}
            >
              <p style={{ color: "red" }}>
                Erro ao processar pagamento no momento, por favor tente
                novamente ou mais tarde
              </p>
            </div>
          </div>
        )}

        {!savePayment && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "80%",
              }}
            >
              <p style={{ color: "yellow" }}>
                O pagamento foi autorizado, mas não conseguimos salvar a
                informação no momento, por favor entre em contato via WhatsApp
              </p>
              <Lottie animationData={animacaoJsonError} loop={true} />
            </div>
          </div>
        )}

        {processing && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "80%",
              }}
            >
              <p style={{ color: "yellow" }}>
                Estamos processando seu pagamento...
              </p>
              <Lottie animationData={animacaoJson} loop={true} />
            </div>
          </div>
        )}

        {dataPayment && savePayment === true && !processing && (
          <div
            style={{
              backgroundColor: "#bcc6be",
              padding: "15px",
              borderRadius: "25px",
              width: "85%",
              margin: "0 auto",
            }}
          >
            <PayPalButtons
              fundingSource="card"
              style={{
                layout: "vertical",
                color: "black",
                shape: "rect",
                fundingicons: true,
                tagline: false,
              }}
              createOrder={(data, actions) => {
                return actions.order.create({
                  purchase_units: [
                    {
                      amount: {
                        value: 59.9,
                      },
                      custom_id: `${plateQuery}-${phoneQuery}`,
                      invoice_id: `${plateQuery}-${phoneQuery}`,
                    },
                  ],
                  payer: {
                    // name: {
                    //   given_name: dataPayment.customer.name,
                    //   surname: dataPayment.customer?.surname || "",
                    // },
                    email_address: emailQuery,
                    phone: {
                      phone_number: {
                        national_number: phoneQuery,
                      },
                    },
                    tax_info: {
                      tax_id_type: "BR_CPF",
                      tax_id: documentQuery,
                    },
                    address: viaCepAddress
                      ? {
                        address_line_1: viaCepAddress.street,
                        admin_area_2: viaCepAddress.city,
                        admin_area_1: viaCepAddress.state,
                        postal_code: viaCepAddress.cep,
                        country_code: "BR",
                      }
                      : undefined,
                  },
                  application_context: {
                    shipping_preference: "NO_SHIPPING",
                  },
                });
              }}
              onApprove={(data, actions) => {
                return actions.order.capture().then((details) => {
                  setProcessing(true);
                  axios
                    .post(
                      `/general-api/vehicle-query`,
                      {
                        plate: plateQuery,
                        phone: phoneQuery,
                        email: emailQuery,
                        document: documentQuery,
                        cep: viaCepAddress.cep,
                        type: "plus",
                        paymentCode: data?.paymentID,
                      },
                      {
                        headers: {
                          "Content-Type": "application/json",
                        },
                      }
                    )
                    .then((response) => {
                      setPaymentConfirmed(true);
                      setProcessing(false);
                    })
                    .catch((error) => {
                      setSavePayment(false);
                      console.error(error);
                    });
                });
              }}
              onError={(err) => {
                console.error(err);
                alert("Ocorreu um erro no processamento do pagamento");
              }}
            />
          </div>
        )}
      </PayPalScriptProvider>
      {dataPayment && savePayment === true && type !== "carWorkshop" && (
        <div
          style={{
            width: "100%",
            height: "5em",
            textAlign: "center",
            marginTop: "2em",
            marginBottom: "5em",
          }}
        >
          {/* <img src="/timeline.png" height="100%" /> */}
        </div>
      )}
      {paymentConfirmed && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#4CAF50",
            color: "white",
            padding: "30px",
            borderRadius: "15px",
            textAlign: "center",
            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            zIndex: 1000,
            maxWidth: "90%",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          <div style={{ marginBottom: "15px" }}>
            <Icon
              icon="mdi:check-circle"
              style={{ fontSize: "48px", color: "white" }}
            />
          </div>
          <div>Pagamento confirmado!</div>
          <div
            style={{
              fontSize: "14px",
              marginTop: "10px",
              fontWeight: "normal",
            }}
          >
            Em breve enviaremos o relatório por WhatsApp.
          </div>
        </div>
      )}
      <div style={{ padding: "30px" }}></div>
    </>
  );
}

export default App;
